import Joi from 'joi';

const dateRangeValidator = Joi.object({
  startDate: Joi.date()
    .label('From Date')
    .max('now')
    .message('From Date must be same or before today\'s date'),
  endDate: Joi.date()
    .label('To Date')
    .max('now')
    .message('To Date must be same or before today\'s date')
    .when('startDate', {
      is: Joi.exist(),
      then: Joi.date().min(Joi.ref('startDate')).message('To Date must be same or after From Date')
    })
});

export default dateRangeValidator;